import { StylesConfig } from 'react-select';

export const selectStyle: StylesConfig = {
    control: (base: any) => ({
        ...base,
        width: '100px',
        border: '1px solid #ccc',
        // This line disable the blue border
        boxShadow: 'none',
        '&:hover': {
            border: '1px solid #ccc',
            boxShadow: '0',
        },
        minHeight: '30px',
        height: '30px',
        borderRadius: 0,
    }),
    valueContainer: (base, props) => ({
        ...base,
        height: '30px',
    }),
    input: (base, props) => ({
        ...base,
        height: '30px',
        margin: '0px',
        padding: '0px',
    }),
    indicatorsContainer: (base, props) => ({
        ...base,
        height: '30px',
    }),
};

export const selectTheme = (theme: any) => ({
    ...theme,
    colors: {
        ...theme.colors,
        primary25: '#449dac',
        primary: '#004652',
    },
});
